(function () {
  var root = document.querySelector('[data-aev]');
  if (!root) return;

  var form = root.querySelector('#aev-form');
  var radios = form ? Array.prototype.slice.call(form.querySelectorAll('input[name="id"]')) : [];
  var priceDisplay = root.querySelector('[data-price-display]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  var zones = Array.prototype.slice.call(root.querySelectorAll('[data-zone]'));

  function currentRadio() {
    return radios.filter(function (r) { return r.checked; })[0] || radios[0];
  }

  function sync() {
    var r = currentRadio();
    if (!r) return;
    var price = r.getAttribute('data-price') || '';
    if (priceDisplay) priceDisplay.innerHTML = price;
    if (stickyPrice) stickyPrice.innerHTML = price;
    zones.forEach(function (z) {
      z.classList.toggle('aev__zone--active', z.getAttribute('data-zone') === r.value);
    });
  }

  radios.forEach(function (r) { r.addEventListener('change', sync); });

  // seatmap zone -> select matching category
  zones.forEach(function (z) {
    function pick() {
      var id = z.getAttribute('data-zone');
      var r = radios.filter(function (x) { return x.value === id; })[0];
      if (r && !r.disabled) { r.checked = true; sync(); }
    }
    z.addEventListener('click', pick);
    z.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
    });
  });

  // hover korespondence: sekce mapy <-> kategorie v seznamu
  function zoneFor(id) { return zones.filter(function (z) { return z.getAttribute('data-zone') === id; })[0]; }
  function optFor(id) { var r = radios.filter(function (x) { return x.value === id; })[0]; return r ? r.closest('.aev__zoneopt') : null; }
  zones.forEach(function (z) {
    var id = z.getAttribute('data-zone');
    z.addEventListener('mouseenter', function () { var o = optFor(id); if (o) o.classList.add('is-hl'); });
    z.addEventListener('mouseleave', function () { var o = optFor(id); if (o) o.classList.remove('is-hl'); });
  });
  radios.forEach(function (r) {
    var o = r.closest('.aev__zoneopt'); if (!o) return;
    o.addEventListener('mouseenter', function () { var z = zoneFor(r.value); if (z) z.classList.add('aev__zone--hl'); });
    o.addEventListener('mouseleave', function () { var z = zoneFor(r.value); if (z) z.classList.remove('aev__zone--hl'); });
  });

  sync();

  // countdown
  var cd = root.querySelector('[data-countdown]');
  if (cd) {
    var target = new Date(cd.getAttribute('data-countdown')).getTime();
    var els = {
      d: cd.querySelector('[data-cd="d"]'), h: cd.querySelector('[data-cd="h"]'),
      m: cd.querySelector('[data-cd="m"]'), s: cd.querySelector('[data-cd="s"]')
    };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = target - Date.now();
      if (isNaN(target)) return;
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (els.d) els.d.textContent = d;
      if (els.h) els.h.textContent = pad(h);
      if (els.m) els.m.textContent = pad(m);
      if (els.s) els.s.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  // sticky ATC: show when main CTA scrolled out
  var sticky = root.querySelector('[data-sticky]');
  if (sticky) {
    sticky.style.background = '#0a0a0a';
    sticky.style.borderTop = '1px solid #262626';
  }
  var cta = form ? form.querySelector('.aev__cta') : null;
  if (sticky && cta && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.hidden = e.isIntersecting;
        if (!e.isIntersecting) {
          sticky.style.background = '#0a0a0a';
          sticky.style.borderTop = '1px solid #262626';
        }
      });
    }, { rootMargin: '0px 0px -20% 0px' });
    io.observe(cta);
    var sSubmit = sticky.querySelector('[data-sticky-submit]');
    if (sSubmit) sSubmit.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }

  // upsells: on ADD TO CART, if any add-on checked, add main + add-ons together then go to cart
  if (form) {
    form.addEventListener('submit', function (e) {
      var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-addon-id]'));
      var checked = boxes.filter(function (b) { return b.checked; });
      if (!checked.length) return; // normal single-item submit
      var r = currentRadio();
      if (!r) return;
      e.preventDefault();
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      var items = [{ id: parseInt(r.value, 10), quantity: qty }];
      checked.forEach(function (b) {
        items.push({ id: parseInt(b.getAttribute('data-addon-id'), 10), quantity: 1 });
      });
      var btn = form.querySelector('.aev__cta');
      if (btn) { btn.textContent = 'ADDING…'; btn.style.pointerEvents = 'none'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) { return res.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { form.submit(); });
    });
  }

  // seatmap: tap-to-zoom vypnuto na mobilu (zamykalo body scroll -> seklá stránka).
  // Na desktopu (jemný pointer) necháme klik-zoom, BEZ zamykání body scrollu.
  var smapImg = root.querySelector('.aev__seatmap-img');
  if (smapImg && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    smapImg.addEventListener('click', function () {
      smapImg.classList.toggle('aev__seatmap-img--zoom');
    });
  }
})();
